/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
import { ClientSDK } from "../lib/sdks.js";
import { BenefitGrants } from "./benefitgrants.js";
import { Downloadables } from "./downloadables.js";
import { PolarCustomers } from "./polarcustomers.js";
import { PolarLicenseKeys } from "./polarlicensekeys.js";
import { PolarOrders } from "./polarorders.js";
import { PolarOrganizations } from "./polarorganizations.js";
import { PolarSubscriptions } from "./polarsubscriptions.js";
export class CustomerPortal extends ClientSDK {
    get benefitGrants() {
        return (this._benefitGrants ?? (this._benefitGrants = new BenefitGrants(this._options)));
    }
    get customers() {
        return (this._customers ?? (this._customers = new PolarCustomers(this._options)));
    }
    get downloadables() {
        return (this._downloadables ?? (this._downloadables = new Downloadables(this._options)));
    }
    get licenseKeys() {
        return (this._licenseKeys ?? (this._licenseKeys = new PolarLicenseKeys(this._options)));
    }
    get orders() {
        return (this._orders ?? (this._orders = new PolarOrders(this._options)));
    }
    get organizations() {
        return (this._organizations ?? (this._organizations = new PolarOrganizations(this._options)));
    }
    get subscriptions() {
        return (this._subscriptions ?? (this._subscriptions = new PolarSubscriptions(this._options)));
    }
}
//# sourceMappingURL=customerportal.js.map